import React, { useState, useEffect } from "react";
import axios from "axios";
import DisplayScoreBatAPI from "../components/DisplayScoreBatAPI";

const API = "https://www.scorebat.com/video-api/v1/";

export default function ScoreBatAPI() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    async function fetchAPI() {
      try {
        await axios.get(API).then((res) => {
          setVideos(res.data);
        });
      } catch (err) {
        alert(err);
      }
    }
    fetchAPI();
  }, []);

  return (
    <>
      <DisplayScoreBatAPI videos={videos} />
     
    </>
  );
}
